export default "__VITE_ASSET__LpsT1Oi0__"